import React, { createContext, useContext, useReducer } from 'react';
import { initialTenantState, TenantReducer } from '../../Components/OrganizationSettings/TenantManagement/TenantReducer';

const TenantContext = createContext();

export const TenantProvider = ({ children }) => {
    const [state, dispatch] = useReducer(TenantReducer, initialTenantState);
    return (
        <TenantContext.Provider value={{ state, dispatch }}>
            {children}
        </TenantContext.Provider>
    );
};

export const useTenant = () => {
    const context = useContext(TenantContext);
    if (!context) {
        throw new Error('useTenant must be used within a TenantProvider');
    }
    return context;
};